import { Link } from 'react-router-dom'

import { layoutCopy } from '../content/layout'
import { DIABETESNINJA_URL, ORG_NAME, ORG_NUMBER, SUPPORT_EMAIL } from '../content/site'
import { PAGES, type Lang } from '../i18n'
import Wordmark from './Wordmark'
import styles from './Footer.module.css'

export default function Footer({ lang }: { lang: Lang }) {
  const t = layoutCopy[lang]
  const home = PAGES.home[lang]

  return (
    <footer className={styles.footer}>
      <div className={`container ${styles.columns}`}>
        <div className={styles.about}>
          <Wordmark size={26} />
          <p className={styles.blurb}>{t.footerBlurb}</p>

          {/* The one link across to the sibling app. It only goes this way until Ronin
              ships; see the note at the top of content/layout.ts. rel="noopener" because
              this is the site's only outbound link. */}
          <p className={styles.sibling}>
            {t.footSiblingLead}{' '}
            <a
              href={DIABETESNINJA_URL}
              className={styles.siblingLink}
              rel="noopener"
            >
              {t.footSiblingLink}
            </a>
          </p>
        </div>

        <div className={styles.column}>
          <h2 className={styles.columnTitle}>{t.footAppTitle}</h2>
          <Link to={home} className={styles.link}>
            {t.navHome}
          </Link>
          <Link to={`${home}#features`} className={styles.link}>
            {t.navFeatures}
          </Link>
          <Link to={`${home}#about`} className={styles.link}>
            {t.navAbout}
          </Link>
          <Link to={PAGES.news[lang]} className={styles.link}>
            {t.navNews}
          </Link>
        </div>

        <div className={styles.column}>
          <h2 className={styles.columnTitle}>{t.footLegalTitle}</h2>
          <Link to={PAGES.privacy[lang]} className={styles.link}>
            {t.navPrivacy}
          </Link>
          <Link to={PAGES.terms[lang]} className={styles.link}>
            {t.navTerms}
          </Link>
        </div>

        <div className={styles.column}>
          <h2 className={styles.columnTitle}>{t.footContactTitle}</h2>
          <Link to={PAGES.contact[lang]} className={styles.link}>
            {t.navContact}
          </Link>
          <a href={`mailto:${SUPPORT_EMAIL}`} className={styles.link}>
            {SUPPORT_EMAIL}
          </a>
          <p className={styles.small}>
            {t.footOrgLine} {ORG_NAME}, {ORG_NUMBER}.
          </p>
        </div>
      </div>

      <div className={`container ${styles.baseline}`}>
        <span>
          {t.footRights} {ORG_NAME}
        </span>
        <span>{t.footNotDevice}</span>
      </div>
    </footer>
  )
}
